import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './locales'
import Header from './components/header.vue'
import Footer from './components/footer.vue'
import LoadScript from 'vue-plugin-load-script'
import VueYoutube from 'vue-youtube'
import VueMeta from 'vue-meta'
import VueGtag from "vue-gtag";

// import { VueReCaptcha } from 'vue-recaptcha-v3'
import * as zenScroll from 'zenscroll';

window.zenScroll = zenScroll

// Global style
import './styles/main.scss'

Vue.config.productionTip = false

Vue.component('header-menu', Header)
Vue.component('footer-menu', Footer)

Vue.use(LoadScript)
Vue.use(VueYoutube)
Vue.use(VueMeta)
Vue.use(VueGtag, {
  config: { id: 'G-BQ7K3H4HNM' },
  appName: 'Arcaea Web',
  pageTrackerScreenviewEnabled: true
}, router);

// Vue.use(VueReCaptcha, { siteKey: '6Lf_MAoaAAAAADD4eS_GrQl-xOiSq_lY7less-ii' })

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
  created() {
    // For song contest
    // this.$router.push('/')
    const html = document.documentElement
    html.setAttribute('lang', i18n.locale)
  }
}).$mount('#app')